import * as S from 'app/components/tables/BaseTableManagement/styles'
import HeaderPage from 'app/components/header/components/HeaderPage'
import R from 'app/assets/R'
import Info from './components/Info'
import BuyInfo from './components/BuyInfo'
import OrderInfo from './components/OrderInfo'
import { ItemCategoryProvider } from 'app/context/ItemCategoryContext'
import { GoodsIssueReceiptProvider } from './context'
import Footer from './components/Footer'

const CreateGoodsIssueReceiptContainer = () => {
  return (
    <GoodsIssueReceiptProvider>
      <ItemCategoryProvider>
        <S.BaseManagementWrapper>
          <HeaderPage
            titleI18nKey={R.strings.ticket_receive}
            rightComponent={<></>}
          />
          <div>
            <div>
              <Info />
              <BuyInfo />
            </div>
          </div>

          <div>
            <div>
              <OrderInfo />
            </div>
          </div>
        </S.BaseManagementWrapper>

        <Footer />
      </ItemCategoryProvider>
    </GoodsIssueReceiptProvider>
  )
}

export default CreateGoodsIssueReceiptContainer
